import React, {memo} from "react";
import PropTypes from "prop-types";
import makeFont from "../../makeFont";
import useBackgroundColor from "../../../Utils/components/BackgroundColorProvider/useBackgroundColor";
import {__TextImplementation as TextImplementation} from "../TextImplementation/TextImplementation";

const sizeMap = {
    large: makeFont(32),
    standard: makeFont(26),
    small: makeFont(24),
    xsmall: makeFont(20),
    xxsmall: makeFont(18),
};

const levelMap = {
    1: "large",
    2: "standard",
    3: "small",
    4: "xsmall",
    5: "xxsmall",
};

const Heading = memo(HeadingImpl);

Heading.propTypes = {
    ...TextImplementation.propTypes,

    /* If you don't pass a level it will throw an error! */
    level: PropTypes.oneOf(Object.keys(levelMap)).isRequired,

    /* Size prop can override the default size of a level */
    size: PropTypes.oneOf(Object.keys(sizeMap)),
};

Heading.defaultProps = {
    ...TextImplementation.defaultProps,
    weight: "700",
};

export default Heading;

/**
 * Can either render the level with the default size or it can be owerwritten.
 *
 * @param {*} {children, size, level}
 * @returns
 */
function HeadingImpl({children, size, level, truncate, transform, weight, ...props}) {
    if (!level) throw new Error("You must specify a level prop");
    const finalSize = size || levelMap[level];
    const fontStyles = sizeMap[finalSize];
    const {status} = useBackgroundColor();
    return (
        <TextImplementation
            weight={weight}
            {...props}
            as={`h${level}`}
            truncate={truncate}
            transform={transform}
            color={status === "dark" ? "#fff" : "var(--body-colour)"}
            fontStyles={fontStyles}
        >
            {children}
        </TextImplementation>
    );
}
